import './_styles.scss';
import React from 'react';

import {
  IoMdCheckbox as Checked,
  IoMdSquareOutline as NotChecked,
  IoMdSync as LoadingIcon
} from 'react-icons/io';

const Option = ({ name, onSelect, selected=false }) => {

  const [checked, select] = React.useState(selected);

  const OptionIcon = (!checked) ? NotChecked : Checked;

  const on_change_filter = () => {

    if (typeof (onSelect) === 'function') onSelect(name);

    return select(!checked);

  }

  return (
    <div className="option noselect" onClick={on_change_filter}>

      <OptionIcon className={`option-icon`} />

      <span className='option-label'>
        {(!!name && name !== '') ? name : 'Generic'}
      </span>

    </div>
  )
}

const PlaceHolder = () => {

  return (
    <div className="option noselect">

      <LoadingIcon className={`option-icon loader`} />

      <span className='option-label'>Loading...</span>

    </div>
  )
}

export default ({ data, selected, onSelect }) => {

  const brands = (!data) ? [] : data.sort((a='', b='') => a.localeCompare(b));

  return (
    <div className='filter-group brand-filter'>

      <div className="Heading">Featured Brands</div>

      {!!data && brands.map((a='', i=0) =>
        <Option
          name={a}
          key={`${a}-${i}`}
          onSelect={onSelect}
          selected={selected.includes(a)}
        />)
      }

      {!data && <PlaceHolder />}

    </div>
  )
}
